import { client } from 'shared';

export default function markUnread(request_body: { receiver_phone_number: string; sender_phone_number: string; to_snooze: boolean; }) {
    return client('tracking/api/external-message/mark-unread/', {
        body: request_body,
        method: 'POST',
    });
}
